import Swiper, { Navigation, Pagination, Autoplay, EffectCreative } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectCreative]);

export function TestimonialsSlider() {
    new Swiper(".testimonials-slider", {
        loop: true,
        speed: 500,
        slidesPerView: 1,
        allowTouchMove: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false
        },
        effect: "creative",
        creativeEffect: {
            prev: {
                shadow: false,
                translate: ["-120%", 0, -500],
            },
            next: {
                shadow: false,
                translate: ["120%", 0, -500],
            },
        },
        breakpoints: {
            768: {
                allowTouchMove: false
            }
        },
        navigation: {
            nextEl: '.testimonial-slider-right',
            prevEl: '.testimonial-slider-left'
        }
    });
}
